import { useCallback, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { getOutboxNotificationDetail } from "../api/outboxNotifications.api";
import type { OutboxNotificationDetail } from "../types/outboxNotifications.types";

export function useOutboxNotificationDetail() {
  const [detail, setDetail] = useState<OutboxNotificationDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { run, loading, cancel } = useLatestRequest();

  const loadDetail = useCallback(async (id: string) => {
    setDetail(null);
    setError(null);
    try {
      const response = await run((signal) => getOutboxNotificationDetail(id, signal));
      if (response) setDetail(response);
    } catch (requestError: unknown) {
      setError(getApiErrorMessage(requestError, "Failed to load Outbox notification details"));
    }
  }, [run]);

  const clearDetail = useCallback(() => {
    cancel();
    setDetail(null);
    setError(null);
  }, [cancel]);

  return { detail, error, loading, loadDetail, clearDetail };
}
